var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":"","align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","sm":"3","data-cy":"block-filter-status"}},[_c('status-selector',{attrs:{"filter":""},model:{value:(_vm.filters.status),callback:function ($$v) {_vm.$set(_vm.filters, "status", $$v)},expression:"filters.status"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }